const strateOngletsTemoignage = {
    init() {
        if ($('.strate-onglets-temoignage').length > 0) {
            const $this = this;
            $('.selecteur_onglet').click(
                function () {
                    $('.strate-onglets-temoignage .selecteur_onglet, .strate-onglets-temoignage .content_onglet').each(
                        function () {
                            $(this).removeClass('active');
                        }
                    );

                    $(this).addClass('active');
                    $($(this).attr('href')).addClass('active');

                    $this.movingOngletBackground();

                    return false;
                }
            );

            this.movingOngletBackground();
            
            const selectTabResp = $('.strate-onglets-temoignage .inner_content_strate_onglets_temoignage .inner_content_wrapper .top_inner_content_responsive #tab_select_responsive_temoignage');
            selectTabResp.on(
                'change', function () {
                    $('.strate-onglets-temoignage .inner_content_strate_onglets_temoignage .inner_content_wrapper .top_inner_content a[href="' + $(this).val() + '"]').trigger('click');
                }
            );
        }
    },
    movingOngletBackground() {
        $('.top_inner_content .onglet-animated-background span').css(
            {
                width: $('.top_inner_content a.active').outerWidth() + 'px',
                left: ($('.top_inner_content a.active').position().left - 5) + 'px',
            }
        );
    },
};

export default strateOngletsTemoignage;
